import { useState, useEffect, useCallback } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InputAdornment from '@mui/material/InputAdornment';
import { Grid, TextField, Button, MenuItem, Typography } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CircularProgress from '@mui/material/CircularProgress';
import { Form as FormikForm, useFormikContext } from "formik";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import { CustomField } from '../../../inputs/CustomField';
import { useAxios } from "../../../../context/AxiosHookContext";
import getDayjs from "../../../../context/DateInstance";

const distributionTypes = [
    "Onza",
    "Libra",
    "Kilogramo",
    "Gramo",
    "Tonelada",
    "Unidad",
    "Paquete",
    "Caja",
    "Saco",
    "Bolsa",
    "Fardo",
    "Mililitro",
    "Litro",
    "Galón",
    "Barril",
    "Rollo",
    "Lata",
    "Botella",
    "Tarro",
    "Blíster",
    "Frasco",
    "Tetra pack"
];

const categories = [
    "Materiales de Limpieza y Mantenimiento",
    "Consumibles",
    "Materiales y Útiles de Oficina",
    "Artículos Promocionales, Prod. Papel y Cartón",
    "Papel Bond y Timbrados Institucional"
];


export const ArticleForm = ({ onClose }) => {

    const { values, setFieldValue, isSubmitting} = useFormikContext();


    useEffect(() => {

       try {

        if (!values.period) {
            setFieldValue("period", getDayjs())
        }


       } catch (error) {
        console.log(error)
       }
        
    }, [getDayjs,values])


    return (
        <FormikForm>
            <Grid container spacing={2} >

                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth>
                        <CustomField name="period" label="Período de adquisición / Fecha de registro" value={values?.period ? getDayjs(values?.period) : getDayjs()} fullWidth as={DateTimePicker}
                            sx={{
                                width: "100%",
                                '& .MuiInputBase-input': {
                                    fontSize: '15px', // Ajusta el tamaño del texto
                                    padding: '8.5px 32px 8.5px 14px',
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <CustomField name="_id" type="number" label="Código Institucional" fullWidth as={TextField} value={values?._id || ""} disabled />
                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <CustomField name="description" multiline rows={2} label="Descripción del artículo" fullWidth as={TextField} value={values?.description || ""} />
                </Grid>

                <Grid container item xs={12} sm={12} md={6} lg={6} spacing={1}>
                    <Grid item xs={6}>
                        <CustomField name="distrUnit" label="Presentación" select fullWidth as={TextField} value={values?.distrUnit || ""}
                            SelectProps={{
                                MenuProps: {
                                    PaperProps: {
                                        style: {
                                            maxHeight: 200, // Altura máxima del menú
                                            overflowY: "auto" // Habilita el scroll vertical
                                        }
                                    }
                                }
                            }}
                        >
                            {
                                distributionTypes.map(dist => (

                                    <MenuItem value={dist} key={dist} >{dist}</MenuItem>
                                ))
                            }
                        </CustomField>
                    </Grid>

                    <Grid item xs={6}>
                        <CustomField name="distrUnitQuantity" type="number" label="Cantidad Presentación" fullWidth as={TextField} value={values?.distrUnitQuantity || ""} />
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} >
                    <CustomField name="unitCost" type="number" label="Costo Unitario" fullWidth as={TextField} value={values?.unitCost || ""} />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <CustomField name="currentValue" type="number" label="Costo Actual" fullWidth as={TextField} value={values?.currentValue || ""} />
                </Grid>

                <Grid container spacing={1} item xs={12} sm={12} md={6} lg={6}>
                    <Grid item xs={6}>
                    <CustomField name="units" type="number" label="Existencia" fullWidth as={TextField} value={values?.units || ""} disabled />
                </Grid>                     
                 <Grid item xs={6}>
                    <CustomField name="minimunStock" type="number" label="Existencia minima" fullWidth as={TextField} value={values?.minimunStock || ""}  />
                </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <CustomField name="category" label="Categoría del item" select fullWidth as={TextField} value={values?.category || null}
                        SelectProps={{
                            MenuProps: {
                                PaperProps: {
                                    style: {
                                        maxHeight: 200, // Altura máxima del menú
                                        overflowY: "auto" // Habilita el scroll vertical
                                    }
                                }
                            }
                        }}
                    >
                        {
                            categories.map(dist => (

                                <MenuItem value={dist} key={dist} >{dist}</MenuItem>
                            ))
                        }
                    </CustomField>
                </Grid>

                <Grid container item xs={12} sm={12} md={6} lg={6} spacing={1}>
                    <Grid item xs={6}>
                        <CustomField name="staticArticle" label="Activo fijo" select fullWidth as={TextField} value={values?.staticArticle || false}
                            SelectProps={{
                                MenuProps: {
                                    PaperProps: {
                                        style: {
                                            maxHeight: 200, // Altura máxima del menú
                                            overflowY: "auto" // Habilita el scroll vertical
                                        }
                                    }
                                }
                            }}
                        >
                            <MenuItem value={true} key={"Si"}>Si</MenuItem>
                            <MenuItem value={false} key={"No"}>No</MenuItem>
                        </CustomField>
                    </Grid>

                    <Grid item xs={6}>
                        <CustomField name="staticArticleCode" type="text" label="Código Activo fijo" fullWidth as={TextField} value={values?.staticArticleCode || ""} />
                    </Grid>

                </Grid>

                <Grid item sm={12} textAlign={"right"} mt={3}>

                    <Button
                        variant="outlined"
                        onClick={() => onClose()}
                        disabled={!((values && !values?.status !== "Created") || false)}
                    >
                        cancelar
                    </Button>

                    <Button sx={{ marginLeft: 2 }}
                        variant="contained"
                        type="submit"
                        disabled={isSubmitting || values?.status === "Finished"}
                    >
                        {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                        {isSubmitting ? 'Guardando' : 'Guardar'}
                    </Button>

                </Grid>

            </Grid>
        </FormikForm>

    );
}

export default ArticleForm;